import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import endpoint from './modules/endpoint'
import wording from './modules/wording'
import customer from './modules/customer'
import product from './modules/product'
import date from './modules/date'
import notify from './modules/notify'
import sku from './modules/sku'
import vendor from './modules/vendor'
import so from './modules/so'
import po from './modules/po'
import warehouse from './modules/warehouse'
import deliveryOrder from './modules/do'
import admin from './modules/admin'
import dashboard from './modules/dashboard'
import partner from './modules/partner'
import coa from './modules/coa'
import costIncome from './modules/cost-income'
import transaction from './modules/transaction'
import financial from './modules/financial'
import nego from './modules/nego'

import general from './general'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function () {
  const Store = new Vuex.Store({
    state: general.state,
    actions: general.actions,
    mutations: general.mutations,
    modules: {
      dashboard,
      date,
      auth,
      endpoint,
      wording,
      notify,
      sku,
      vendor,
      warehouse,
      so,
      po,
      admin,
      partner,
      customer,
      product,
      coa,
      costIncome,
      do: deliveryOrder,
      transaction,
      financial,
      nego
    },

    strict: process.env.DEBUGGING
  })

  return Store
}
